module.exports = "/_next/static/images/golden-ticket-shining-00647c90624ad56a93217fba6f1a2aa3.png";